import styles from "./rules.module.css"

export default function Rules({ rules }) {
  return (
    <div className={styles.rulesCard}>
      <h2 className={styles.sectionTitle}>Tournament Rules</h2>
      <div className={styles.rulesContent}>
        {rules.split("\n").map((rule, index) => (
          <p key={index} className={styles.ruleLine}>
            {rule}
          </p>
        ))}
      </div>
    </div>
  )
}
